var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 35,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F26221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5851F"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M36.13 19.102a2.082 2.082 0 0 1-2.968 0L19.287 5.072a1.227 1.227 0 0 0-1.697 0L3.717 19.103a2.083 2.083 0 0 1-2.969 0 2.14 2.14 0 0 1 0-3.002L14.622 2.065a5.474 5.474 0 0 1 7.631 0l4.132 4.178V4.006a2.11 2.11 0 0 1 2.052-2.076 2.108 2.108 0 0 1 2.144 2.076v6.483l5.549 5.612V16.1a2.14 2.14 0 0 1 0 3.002zM17.712 9.099v-.001a1.021 1.021 0 0 1 1.457.001l12.203 12.338c.193.196.302.462.301.738v9c0 2.111-1.692 3.824-3.781 3.824h-6.041v-9.464H15.03v9.464H8.988c-2.088 0-3.781-1.713-3.781-3.824v-9c0-.276.108-.542.301-.738L17.712 9.099z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M36.13 19.102a2.082 2.082 0 0 1-2.968 0L19.287 5.072a1.227 1.227 0 0 0-1.697 0L3.717 19.103a2.083 2.083 0 0 1-2.969 0 2.14 2.14 0 0 1 0-3.002L14.622 2.065a5.474 5.474 0 0 1 7.631 0l4.132 4.178V4.006a2.11 2.11 0 0 1 2.052-2.076 2.108 2.108 0 0 1 2.144 2.076v6.483l5.549 5.612V16.1a2.14 2.14 0 0 1 0 3.002zM17.712 9.099v-.001a1.021 1.021 0 0 1 1.457.001l12.203 12.338c.193.196.302.462.301.738v9c0 2.111-1.692 3.824-3.781 3.824h-6.041v-9.464H15.03v9.464H8.988c-2.088 0-3.781-1.713-3.781-3.824v-9c0-.276.108-.542.301-.738L17.712 9.099z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/houseIcon.0ed43e95b435c3eb6310803522f359a7.svg";
export { ForwardRef as ReactComponent };